<template>
  <div>
    <NavBtns></NavBtns>

    <!--教學影片-->
    <section id="insa">
      <div class="video">
        <iframe
          v-if="!is_offline"
          src="https://www.youtube.com/embed/8tylQhiT1VE"
          frameborder="0"
          allowfullscreen=""
        ></iframe>
        <div class="offlinebox" :class="{ show: is_offline }">
          <div class="offallbox">
            <div class="imgbox">
              <img
                class="img-fluid"
                src="../assets/images/offline.svg"
                alt="offline"
              />
            </div>
            <div class="text">{{ $t('message.op_movie_offline') }}</div>
          </div>
        </div>
      </div>
      <div class="buttonbox d-none d-xl-block">
        <a class="page-scroll" href="#insb">
          <div class="button">{{ $t('message.op_deposit_title') }}</div></a
        >
        <a class="page-scroll" href="#insc">
          <div class="button">{{ $t('message.op_takeout_title') }}</div></a
        >
        <a class="page-scroll" href="#insd">
          <div class="button">{{ $t('message.op_supp_title') }}</div></a
        >
      </div>
    </section>

    <!--寄放行李-->
    <section id="insb">
      <div class="container">
        <div class="row">
          <div class="col-xl-6 col-md-6 col-sm-12">
            <div class="blackbox">{{ $t('message.op_deposit_desc') }}</div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-12">
            <div class="imgbox">
              <div class="featureB2">
                <img
                  class="img-fluid"
                  src="../assets/images/feature_b02.svg"
                  alt="OWLocker智慧型寄物櫃,小型"
                />
              </div>
              <div class="featureB3">
                <img
                  class="img-fluid"
                  src="../assets/images/feature_b03.svg"
                  alt="OWLocker智慧型寄物櫃,行李箱"
                />
              </div>
              <div class="arrow_right">
                <img
                  class="img-fluid"
                  src="../assets/images/arrow_right.svg"
                  alt="OWLocker智慧型寄物櫃"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="insb2">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-4 col-md-6"
            v-for="(step, index) in deposit_steps"
            v-bind:key="index"
          >
            <div class="imgbox">
              <img class="img-fluid" :src="step.img" alt="寄放行李" />
              <p>{{ $t('message.' + step.desc_label) }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--取出行李-->
    <section id="insc">
      <div class="container">
        <div class="row">
          <div class="col-xl-6 col-md-6 col-sm-12">
            <div class="blackbox">{{ $t('message.op_takeout_desc') }}</div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-12">
            <div class="imgbox">
              <div class="featureC2">
                <img
                  class="img-fluid"
                  src="../assets/images/feature_b02.svg"
                  alt="OWLocker智慧型寄物櫃,小型"
                />
              </div>
              <div class="featureC3">
                <img
                  class="img-fluid"
                  src="../assets/images/feature_b03.svg"
                  alt="OWLocker智慧型寄物櫃,行李箱"
                />
              </div>
              <div class="arrow_left">
                <img
                  class="img-fluid"
                  src="../assets/images/arrow_left.svg"
                  alt="OWLocker智慧型寄物櫃"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="insc2">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-4 col-md-6"
            v-for="(step, index) in takeout_steps"
            v-bind:key="index"
          >
            <div class="imgbox">
              <img class="img-fluid" :src="step.img" alt="取出行李" />
              <p>{{ $t('message.' + step.desc_label) }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--補充-->
    <section id="insd">
      <div class="container">
        <div class="row">
          <div class="col-xl-6 col-md-6 col-sm-12">
            <div class="blackbox">{{ $t('message.op_supp_title') }}</div>
          </div>
          <div class="col-xl-6 col-md-6 col-sm-12">
            <div class="featureD1">
              <img
                class="img-fluid"
                src="../assets/images/instruction_01.svg"
                alt="補充"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="insd2">
      <div class="container">
        <div class="row">
          <div
            class="col-xl-6 col-md-6"
            v-for="(supp, index) in supp_datas"
            v-bind:key="index"
          >
            <div class="imgbox">
              <img class="img-fluid" :src="supp.img" :alt="supp.alt" />
              <p>{{ $t('message.' + supp.desc_label) }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--頁尾-->
    <GzFooter></GzFooter>
  </div>
</template>

<script>
import { mapState } from 'vuex';

// @ is an alias to /src
import NavBtns from '@/components/NavBtns.vue';
import GzFooter from '@/components/GzFooter.vue';

export default {
  name: 'Operation',
  components: {
    NavBtns,
    GzFooter,
  },
  data: function () {
    return {
      deposit_steps: [
        {
          img: './img/operation/deposit_00.jpg',
          desc_label: 'op_deposit_step0',
        },
        {
          img: './img/operation/deposit_01.jpg',
          desc_label: 'op_deposit_step1',
        },
        {
          img: './img/operation/deposit_02.jpg',
          desc_label: 'op_deposit_step2',
        },
        {
          img: './img/operation/deposit_03.jpg',
          desc_label: 'op_deposit_step21',
        },
        {
          img: './img/operation/deposit_04.jpg',
          desc_label: 'op_deposit_step3',
        },
        {
          img: './img/operation/deposit_05.jpg',
          desc_label: 'op_deposit_step31',
        },
        {
          img: './img/operation/deposit_06.jpg',
          desc_label: 'op_deposit_step32',
        },
        {
          img: './img/operation/deposit_07.jpg',
          desc_label: 'op_deposit_step4',
        },
        {
          img: './img/operation/deposit_08.jpg',
          desc_label: 'op_deposit_step41',
        },
        {
          img: './img/operation/deposit_09.jpg',
          desc_label: 'op_deposit_step5',
        },
        {
          img: './img/operation/deposit_10.jpg',
          desc_label: 'op_deposit_step51',
        },
        {
          img: './img/operation/deposit_11.jpg',
          desc_label: 'op_deposit_step6',
        },
      ],
      takeout_steps: [
        {
          img: './img/operation/takeout_00.jpg',
          desc_label: 'op_takeout_step0',
        },
        {
          img: './img/operation/takeout_01.jpg',
          desc_label: 'op_takeout_step1',
        },
        {
          img: './img/operation/takeout_02.jpg',
          desc_label: 'op_takeout_step2',
        },
        {
          img: './img/operation/takeout_03.jpg',
          desc_label: 'op_takeout_step3',
        },
        {
          img: './img/operation/takeout_04.jpg',
          desc_label: 'op_takeout_step31',
        },
        {
          img: './img/operation/takeout_05.jpg',
          desc_label: 'op_takeout_step32',
        },
        {
          img: './img/operation/takeout_06.jpg',
          desc_label: 'op_takeout_step33',
        },
        {
          img: './img/operation/takeout_07.jpg',
          desc_label: 'op_takeout_step4',
        },
      ],
      supp_datas: [
        {
          img: './img/operation/add_01.jpg',
          desc_label: 'op_supp_01',
          alt: 'OWLocker智慧型寄物櫃,小型',
        },
        {
          img: './img/operation/add_02.jpg',
          desc_label: 'op_supp_02',
          alt: 'OWLocker智慧型寄物櫃,大型',
        },
        {
          img: './img/operation/add_04.jpg',
          desc_label: 'op_supp_03',
          alt: '門不會自動彈開',
        },
        {
          img: './img/operation/add_03.jpg',
          desc_label: 'op_supp_04',
          alt: '容易造成門卡住打不開',
        },
        {
          img: './img/operation/deposit_07.jpg',
          desc_label: 'op_supp_05',
          alt: '密碼紙列印',
        },
        {
          img: './img/operation/add_05.jpg',
          desc_label: 'op_supp_06',
          alt: '隨手關門鎖上',
        },
      ],
    };
  },
  computed: {
    //網路連線狀態
    is_offline: function () {
      return this.net_offline;
    },
    ...mapState({
      net_offline: (state) => state.is_offline,
    }),
  },
  mounted: function () {},
  methods: {
    //網路連線狀態改變為 online 時觸發
    vNetworkOnline: function () {
      //取得合作廠商
      this.vLoadPartners();
    },
    //網路連線狀態改變為 offline 時觸發
    vNetworkOffline: function () {},
  },
  watch: {
    net_offline: function (new_val) {
      if (new_val) {
        this.vNetworkOffline();
      } else {
        this.vNetworkOnline();
      }
    },
  },
};
</script>
